<template>
<textarea :id="thisId" ></textarea>
</template>

<script>
import '../css/layout.css'
import tinymce from 'tinymce';

export default {
  props: ['height','language','initvalue'],
  data() {
    return {
       dataValue:''
    }
  },
  created () {
    console.log("TINYMCE CREATO");
    this.thisId="tinymce-"+this.$teras.random()
    console.log(this.height+' '+this.initvalue)
  },  
  mounted (){
    this.dataValue = this.initvalue
    //console.log("TINYMCE MOUNTING + "+this.dataValue)
    this.tinymceInit()
    //console.log("TINYMCE MOUNTED + "+this.dataValue)
    
    //console.log(tinymce.activeEditor.plugins.wordcount.getCount())
  },
  destroyed(){
    //tinymce.remove()
  },
  watch: {
    '$teras.language':  'terasChange'
  },
  methods: {
    countChange(){
      console.log("SE FUNZIONA "+tinymce.activeEditor.plugins.wordcount.getCount())
    },
    terasChange(){
      tinymce.remove()
      //tinymce.init({language : self.$teras.language})
      console.log("DA ABSTRACT IN LINGUA" + this.$teras.language)
      //tinyMCE.execCommand(“mceRepaint”);
      var self = this
      tinyMCE.execCommand("mceRepaint")
      this.tinymceInit()
    },
    tinymceInit(){
        var self = this
        console.log("tinymceInit ABS-TINYMCE "+this.dataValue)
        console.log('#'+this.$el.id)
        console.log(document.styleSheets[2])
        console.log(this.dataValue)
        //tinyMCE.baseURL = "https://cdn.tinymce.com/4"
        tinyMCE.baseURL = "/abstract-submit-2025/js/tinymce"
        this.tiny = tinymce.init({
            selector: '#'+self.$el.id,
            menubar: false,
            height: self.height,
            language : 'en',
            //language_url : '/201706/langs/it.js',
            content_css : "/abstract-submit-2025/css/layout.css",
            //content_css : document.styleSheets[0],
            oninit : "setPlainText",
            entity_encoding : "raw",
            forced_root_block : false,
            //valid_elements : 'p,a[*],li,ul,ol,div[*],span[*],img[*],sup,sub,br,strong/b,em,hr,h1,h2,h3,h4,h5,h6,table,tr,td,router-link[*]',
            valid_elements : 'sup,sub,br,strong/b',

            relative_urls : false,
            plugins: [
            'paste',
            'charmap',
            'wordcount,fullscreen',
            'contextmenu ',
            'code'
            ],
            contextmenu: "charmap | subscript  superscript | copy paste",
            //toolbar1: 'undo redo |  styleselect | bold italic | subscript  superscript | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | charmap | fullscreen',
            toolbar1: 'undo redo |   subscript  superscript |  charmap | fullscreen',// | code',

            
            setup: (editor) =>{
            console.log("SETUP TINYMCE")
            console.log(this.$el.id)
            console.log(this.dataValue)
            
            // init tinymce
            editor.on('init', (e) =>{

            tinymce.setActive(e.target) //setto come attivo l'editor in questione
            tinymce.get(this.$el.id).setContent(this.dataValue);
                         
            });
            editor.on('SetContent', (e) =>{
              //console.log(tinymce.get(this.$el.id).plugins.wordcount.getCount())
              //tinymce.setActive(e.target) //setto come attivo l'editor in questione
              console.log("ARRIVO AL SET CONTENT PER "+this.thisId)
              console.log(this.dataValue)
              this.$emit('input', e.content)
              this.$emit('change', e.content, tinymce.get(this.$el.id).plugins.wordcount.getCount())
            });
            editor.on('keyup change', (e) =>{
                //let theEditor = tinymce.activeEditor
                let wordCount = tinymce.get(this.$el.id).plugins.wordcount.getCount()

                let new_value = tinymce.get(self.$el.id).getContent()
                this.$emit('input', new_value)
                this.$emit('change', new_value, wordCount)
            });
                        
            }
        })
        console.log("FINITA")
      }
  }
  
}

</script>